module.exports = __webpack_public_path__ + "static/img/gzh_qrcode.e8b6776.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gzh_qrcode.png
// module id = SgJN
// module chunks = 0